// extracted by mini-css-extract-plugin
module.exports = {"label":"FilterItem_label__3z2bH"};